import React from 'react';
import { Avatar, Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import EditIcon from '@mui/icons-material/Edit';
import CreateUserForm from './CreateUserForm';

export default function UserFormDialog({ open, user, onClose, onSaved }) {
  const isEdit = Boolean(user);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <Avatar sx={{ bgcolor: '#0D6AEE' }}>{isEdit ? <EditIcon /> : <PersonAddAlt1Icon />}</Avatar>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            {isEdit ? `Editar ${user.nombre || user.username}` : 'Crear usuario'}
          </Typography>
          <Typography variant="caption" sx={{ color: '#6b7280' }}>
            {isEdit ? `@${user.username}` : 'Da de alta a un nuevo miembro del equipo'}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ backgroundColor: '#f8fafc' }}>
        <CreateUserForm user={user} onSuccess={onSaved} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
}
